/// <reference path="../Scripts/typings/knockout.mapping/knockout.mapping.d.ts" />
/// <reference path="../Scripts/registry.d.ts" />

import * as ko from "knockout";

export interface TypeSelectorParams {
    typeSource: any;
    itemParameters: any;
    selectedItem: any;
}

export function TypeSelectorViewModel(params: TypeSelectorParams) {
    this.params = params;
    let types = Object.keys(params.typeSource);
    this.selectedItem = params.selectedItem;
    this.typeSource = ko.observableArray(types);
    // this.selectedItem = params.selectedItem
    this.selectedType = ko.observable(params.selectedItem.type());
    this.dirty = ko.observable(false);

    this.selectedType.subscribe((newVal) => {
        this.dirty(true);
        console.log("newval", newVal, this.selectedItem);
        this.selectedItem.type(this.selectedType());
    });

    this.param = params.itemParameters.param;
    let initalType = params.itemParameters() == undefined ? "" : params.itemParameters().type;
    this.selectedItemType = ko.observable(initalType);

    this.updateItem = () => {
        this.dirty(false);
        console.log("setting changes to trigger", this.selectedItem);

        this.selectedItem.type(this.selectedType());
    };

    this.selectedTypeDescription = (type) =>
        type && params.typeSource[type].description ? params.typeSource[type].description : "Missing description";

    this.getParamDescription = (type, key) =>
        type.paramsDescription && type.paramsDescription[key] ? type.paramsDescription[key] : "Missing description";

    this.getParams = () => {
        if (
            params.typeSource[this.selectedType()] != undefined &&
            params.typeSource[this.selectedType()].params != undefined
        ) {
            this.param = Object.assign({}, params.typeSource[this.selectedType()].params);

            let paramArray = [];

            console.log("params.typeSource", params.typeSource);
            console.log("this.param", this.param);

            for (let key in this.param) {
                var val = this.param[key];

                if (this.params.selectedItem.params[key] != null) val = this.params.selectedItem.params[key]();

                let singleParam = {
                    name: key,
                    value: ko.observable(val),
                    description: this.getParamDescription(params.typeSource[this.selectedType()], key),
                };

                singleParam.value.subscribe((nv) => {
                    console.log("setting itemparams");
                    if (!this.params.selectedItem.params[key]) this.params.selectedItem.params[key] = ko.observable();

                    this.params.selectedItem.params[key](nv);
                });

                paramArray.push(singleParam);
            }

            console.log("paramArray", paramArray);

            return paramArray;
        } else {
            return [];
        }
    };
}

declare var registry: any;
registry.registerComponent("web", "type-selector", TypeSelectorViewModel);
